import type { PrioridadeHome } from '../types/prioridadesTypes';

// TODO: mock front-only — substituir pela leitura das pendências abertas do usuário quando o backend expor o agregado de prioridades.
// Mantido desativado para não apresentar pendências fictícias aos usuários.
export const EXIBIR_PRIORIDADES_HOME_MOCK = false;

export const PRIORIDADES_HOME_MOCK: PrioridadeHome[] = [
  {
    id: 'prioridade-custas-1',
    tipo: 'PAGAMENTO_CUSTAS',
    titulo: 'Pagamento das custas pendente',
    subtitulo: 'ARB-2026-0148 · Construtora Andrade × J. M. Locações',
    detalhe: 'R$ 1.240,00 · vence em 3 dias',
    processoId: 'arb-2026-0148',
  },
];
